module.exports = __webpack_public_path__ + "624c1255/img/60000000-8.4ba90d61.png";